import createReducer from "./reducerUtils";
import {
    LOAD_SESSIONS,
    LOADING_SESSIONS,
    LOADING_CLOSE_SESSION,
    LOADING_CLOSE_ALL_SESSIONS,
} from "../actions/actionTypes";

const initialState = {
    sessions: [],
    loadingSessions: false,
    loadingCloseSession: false,
    loadingCloseAllSessions: false,
};

const loadSessions = (state, payload) => {
    return {
        ...state,
        sessions: payload.sessions,
    };
};

const loadingSessions = (state, payload) => {
    return {
        ...state,
        loadingSessions: payload.loadingSessions
    };
};

const loadingCloseSession = (state, payload) => {
    return {
        ...state,
        loadingCloseSession: payload.loadingCloseSession
    };
};

const loadingCloseAllSessions = (state, payload) => {
    return {
        ...state,
        loadingCloseAllSessions: payload.loadingCloseAllSessions
    };
};

export default createReducer(initialState, {
    [LOAD_SESSIONS]: loadSessions,
    [LOADING_SESSIONS]: loadingSessions,
    [LOADING_CLOSE_SESSION]: loadingCloseSession,
    [LOADING_CLOSE_ALL_SESSIONS]: loadingCloseAllSessions,
});